import React from 'react'
import './LandownerShare.css'
import './Project-Details.css'
import Trilight_Img from '../images/hyd-projects/Trilight.jpg'
import { useEffect } from 'react';
import { FaCheckCircle } from 'react-icons/fa';
import { FaBuilding, FaCouch, FaArrowCircleUp, FaHighlighter, FaGolfBall } from 'react-icons/fa';
import Trilight_One from '../images/Trilight-gal-one.jpg'
import Trilight_Two from '../images/Trilight-gal-two.jpg'
import Trilight_Three from '../images/Trilight-gal-three.jpg'
import Trilight_Four from '../images/Trilight-gal-four.jpg'



function Trilight() {

    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to top on page load
    }, []);

    return (
        <div className='landowner-main'>
            {/* Landowner Hero */}
            <div className='trilight-hero landowner-hero d-flex justify-content-center align-items-center'>
                <h1 className='syne-title text-white text-uppercase'> <span className='text-rose'>T</span>he <span className='text-rose'>T</span>rilight</h1>
            </div>
            {/* Landowner Hero */}
            {/* Landowner About */}
            <div className='landowner-about container-fluid py-4'>
                <div className='landowner-about-inner container py-4'>
                    <h4 className='syne-title text-center mb-4 fs-2'></h4>
                    <div className='row'>
                        <div className='col-lg-6 my-2'>
                            <img src={Trilight_Img} className='img-fluid shadow-sm rounded' />
                        </div>
                        <div className='col-lg-6 my-2 px-2 py-1 d-flex justify-content-center align-items-center'>

                            <div className='landowner-about-one-right text-secondary'>

                                <h4 className='syne-title mb-2 fs-3 text-dark'>Luxury High Rise
                                    3 | 4 | 5 BHK Apartments In Kokapet</h4>
                                <p>
                                    Welcome to a luxurious lifestyle redefined, where modern architecture meets timeless elegance. Immerse yourself in world-class amenities, thoughtfully crafted spaces, and unparalleled comfort that cater to your every need. Discover a living experience that blends sophistication, convenience, and tranquility, elevating your lifestyle to extraordinary heights.
                                </p>
                                <div className="highlights-container">
                                    <ul className="highlight-list">
                                        <li className="highlight-item">
                                            <FaCheckCircle className="icon text-rose" />
                                            <span>
                                                3 highrise towers namely Canopus 56 floors, Vega 46 floors and Rigel 49 floors
                                            </span>
                                        </li>
                                        <li className="highlight-item">
                                            <FaCheckCircle className="icon text-rose" />
                                            <span>
                                                462 high-quality built luxury residences spread across 4.23 acres
                                            </span>
                                        </li>
                                        <li className="highlight-item">
                                            <FaCheckCircle className="icon text-rose" />
                                            <span>
                                                Grand outdoor living areas that create a lavish yet relaxed lifestyle for the owners
                                            </span>
                                        </li>
                                        <li className="highlight-item">
                                            <FaCheckCircle className="icon text-rose" />
                                            <span>
                                                The construction of this project is being managed by the ever trusted TATA projects
                                            </span>
                                        </li>
                                        <li className="highlight-item">
                                            <FaCheckCircle className="icon text-rose" />
                                            <span>100% Vaasthu Compliant</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        {/* <div className='col-lg-6 my-2 p-3 d-flex justify-content-center align-items-center'>
              <div className='landowner-about-one-right'>
                <p>
                In the dynamic world of real estate investment, innovative opportunities are constantly emerging to cater to the diverse needs of investors. One such approach gaining traction is the concept of Land Owner Shares (LOS) and the associated benefits of investing in apartments that offer these shares.</p>
                <p>Land Owner Shares provide an exciting and accessible avenue for real estate investment, making it easier for investors to participate in property ownership through this modern strategy.</p>
              </div>
            </div>
            <div className='col-lg-6 my-2'>
              <img src={Landowner_About_Two} className='img-fluid shadow-sm rounded' />
            </div> */}
                    </div>
                </div>
            </div>
            {/* Landowner About */}
            {/* Landowner Benefits */}
            <div className='landowner-benefit container-fluid py-4 bg-light'>
                <div className='landowner-benefit-inner container py-4'>
                    <h1 className='syne-title text-center'>Key Highlights<span className='text-rose'>.</span></h1>
                    <p className='text-center text-secondary'>Discover the unmatched luxury and exclusivity with three stunning towers, surrounded by 78% open area that offers abundant green spaces. Our apartments come in various sizes ranging from 2,888 Sq. ft. to 5,777 Sq. ft., allowing you to choose the perfect home for your needs.</p>
                    <div className="container my-2">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-4 col-md-6 my-3">
                                    <div className="card h-100 text-center p-4 border-0 shadow-sm">
                                        <div className="card-icon mb-3">
                                            <i className="fas fa-building fa-3x text-rose"></i>
                                        </div>
                                        <div className="card-body">
                                            <h5 className="card-title">3 Towers</h5>
                                            <p className="text-secondary">The project features three high-rise towers, providing ample space and panoramic views for every resident.</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-4 col-md-6 my-3">
                                    <div className="card h-100 text-center p-4 border-0 shadow-sm">
                                        <div className="card-icon mb-3">
                                            <i className="fas fa-tree fa-3x text-rose"></i>
                                        </div>
                                        <div className="card-body">
                                            <h5 className="card-title">78% Open Area</h5>
                                            <p className="text-secondary">With 78% open area, the project offers abundant greenery and open spaces for a healthier and more relaxing environment.</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-4 col-md-6 my-3">
                                    <div className="card h-100 text-center p-4 border-0 shadow-sm">
                                        <div className="card-icon mb-3">
                                            <i className="fas fa-ruler-combined fa-3x text-rose"></i>
                                        </div>
                                        <div className="card-body">
                                            <h5 className="card-title">Apartment Sizes</h5>
                                            <p className="text-secondary">Apartments range from 2,888 Sq. ft. to 5,777 Sq. ft., providing a variety of spacious options to suit your needs.</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-4 col-md-6 my-3">
                                    <div className="card h-100 text-center p-4 border-0 shadow-sm">
                                        <div className="card-icon mb-3">
                                            <i className="fas fa-compass fa-3x text-rose"></i>
                                        </div>
                                        <div className="card-body">
                                            <h5 className="card-title">360° View from Central Courtyard</h5>
                                            <p className="text-secondary">Enjoy stunning 360° views from the central courtyard, offering an unparalleled visual experience from every angle.</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-4 col-md-6 my-3">
                                    <div className="card h-100 text-center p-4 border-0 shadow-sm">
                                        <div className="card-icon mb-3">
                                            <i className="fas fa-archive fa-3x text-rose"></i>
                                        </div>
                                        <div className="card-body">
                                            <h5 className="card-title">Limited Edition Homes</h5>
                                            <p className="text-secondary">A limited number of homes available from the 38th to the 56th floor, offering exclusive living experiences with breathtaking views.</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-4 col-md-6 my-3">
                                    <div className="card h-100 text-center p-4 border-0 shadow-sm">
                                        <div className="card-icon mb-3">
                                            <i className="fas fa-building fa-3x text-rose"></i>
                                        </div>
                                        <div className="card-body">
                                            <h5 className="card-title">TATA Projects</h5>
                                            <p className="text-secondary">Built by Tata Projects, known for delivering exceptional quality and excellence in construction.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            {/* Landowner Benefits */}
            {/* Project Gallery */}
            <div className='gallery container-fluid py-4'>
                <div className='gallery-inner container py-4'>
                    <h1 className='syne-title'>GALLERY<span className='text-rose'>.</span></h1>
                    <div className='row'>
                        <div className='col-lg-3 my-3 h-100'>
                            <img src={Trilight_One} className='img-fluid rounded-10' />
                        </div>
                        <div className='col-lg-3 my-3 h-100'>
                            <img src={Trilight_Two} className='img-fluid rounded-10' />
                        </div>
                        <div className='col-lg-3 my-3 h-100'>
                            <img src={Trilight_Three} className='img-fluid rounded-10' />
                        </div>
                        <div className='col-lg-3 my-3 h-100'>
                            <img src={Trilight_Four} className='img-fluid rounded-10' />
                        </div>
                    </div>
                </div>
            </div>
            {/* Project Gallery */}
            {/* Landowner Benefits */}
            <div className='landowner-benefit container-fluid py-4 bg-light'>
                <div className='landowner-benefit-inner container py-4'>
                    <h1 className='syne-title text-center'>Amenities<span className='text-rose'>.</span></h1>
                    <p className='text-center text-secondary'>Enjoy a wide range of facilities, including multiple lounges for relaxation, single-loaded corridors for privacy, and a golf simulator to practice your skills. These offerings ensure you have everything you need to live in style and sophistication.</p>
                    <div className="container my-2">
                        <div className="row">
                            <div className="col-lg-4 col-md-6 my-3">
                                <div className="card h-100 text-center p-4 border-0 shadow-sm">
                                    <div className="card-icon mb-3">
                                        <i className="fas fa-building fa-3x text-rose"></i>
                                    </div>
                                    <div className="card-body">
                                        <h5 className="card-title fw-bold syne-title">Three Club Houses</h5>
                                        <p className="text-secondary">
                                            At different levels that are one of a kind, offering exclusive and luxurious experiences.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 my-3">
                                <div className="card h-100 text-center p-4 border-0 shadow-sm">
                                    <div className="card-icon mb-3">
                                        <i className="fas fa-highlighter fa-3x text-rose"></i>
                                    </div>
                                    <div className="card-body">
                                        <h5 className="card-title fw-bold syne-title">High Ceilings</h5>
                                        <p className="text-secondary">
                                            Lobbies designed with sheer opulence to create a grand entrance for residents.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 my-3">
                                <div className="card h-100 text-center p-4 border-0 shadow-sm">
                                    <div className="card-icon mb-3">
                                        <i className="fas fa-couch fa-3x text-rose"></i>
                                    </div>
                                    <div className="card-body">
                                        <h5 className="card-title fw-bold syne-title">Multiple Lounges</h5>
                                        <p className="text-secondary">
                                            For leisure, entertainment, and private conversations in comfort and style.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 my-3">
                                <div className="card h-100 text-center p-4 border-0 shadow-sm">
                                    <div className="card-icon mb-3">
                                        <i className="fas fa-arrow-circle-up fa-3x text-rose"></i>
                                    </div>
                                    <div className="card-body">
                                        <h5 className="card-title fw-bold syne-title">Private Lifts</h5>
                                        <p className="text-secondary">
                                            That open up directly to your house, ensuring convenience and privacy.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 my-3">
                                <div className="card h-100 text-center p-4 border-0 shadow-sm">
                                    <div className="card-icon mb-3">
                                        <i className="fas fa-building fa-3x text-rose"></i>
                                    </div>
                                    <div className="card-body">
                                        <h5 className="card-title fw-bold syne-title">Single Loaded Corridors</h5>
                                        <p className="text-secondary">
                                            Offering complete privacy and a first-of-its-kind design for residents.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 my-3">
                                <div className="card h-100 text-center p-4 border-0 shadow-sm">
                                    <div className="card-icon mb-3">
                                        <i className="fas fa-golf-ball fa-3x text-rose"></i>
                                    </div>
                                    <div className="card-body">
                                        <h5 className="card-title fw-bold syne-title">Golf Simulator</h5>
                                        <p className="text-secondary">
                                            Perfect for practicing your tee-off and enjoying a sophisticated sport.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            {/* Landowner Benefits */}
            {/* Contact Map */}
            <div className='contact-map container'>
                <div className='container row py-4 justify-content-center w-100'>
                    <div className='col-lg-6'>
                        <h1 className='syne-title text-start'>LOCA<span className='text-rose'>T</span>ION<span className='text-rose'>.</span></h1>
                        <p className='text-secondary text-start'>Explore our diverse range of locations, each offering unique experiences and exceptional services tailored to meet your needs.</p>
                    </div>
                    <div className='col-lg-6'></div>
                </div>
            </div>
            <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15228.873157931499!2d78.3330205!3d17.4013088!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb951cc98404bb%3A0x17bd70f88466519d!2sThe%20Trilight!5e0!3m2!1sen!2sin!4v1732614598488!5m2!1sen!2sin" width="100%" height="450" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
            {/* Contact Map */}
        </div>
    )
}

export default Trilight